import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from '../redux/connect';
import { navigateToIssueInDocumentAction } from '../redux/actions';
import lodashGet from 'lodash/get';
import cx from 'classnames';
import T from 'i18n-react';
import { isNullOrUndefined } from '@adsk/bim360-matrix-react-components';

export class PureDocumentDisplayName extends PureComponent {

  handleNavigateToIssueInDocument() {
    const { issueId, navigateToIssueInDocumentAction, location, document } = this.props;
    navigateToIssueInDocumentAction(document.urn, issueId, location);
  }

  renderDocumentText() {
    const { allowLink, document, issueStartingVersion } = this.props;

    if (!document) {
      return (
        <div className="DocumentDisplayField__unspecified">
          {T.translate('issueAttributes.document.unspecified')}
        </div>
      );
    }

    const documentName = document.name || lodashGet(document, 'currentVersion.title');
    const documentVersion = isNullOrUndefined(document.version) ? document.latestVersion : document.version;

    if (!documentName) {
      return (
        <div className="DocumentDisplayName__na">
          {T.translate('issueAttributes.document.unknown')}
        </div>
      );
    }

    const nameDivClassNames = cx('DocumentDisplayName__name', {
      'DocumentDisplayName__name--link': allowLink,
    });

    const isCurrentVersion = issueStartingVersion === documentVersion;
    const currentVersionText = isCurrentVersion ? `, ${T.translate('version.currentIndicator')}` : '';
    const onDocumentClick = allowLink ? () => this.handleNavigateToIssueInDocument() : undefined;
    return (
      <div className="DocumentDisplayName__name-wrapper">
        <span
          className={nameDivClassNames}
          data-testid="DocumentDisplayName__name"
          onClick={onDocumentClick}
        >
          {documentName}
        </span>
        {
          documentVersion && <span className="DocumentDisplayName__version">
            {`[${T.translate('version.shorthand')}${issueStartingVersion}${currentVersionText}]`}
          </span>
        }
      </div>
    );
  }

  render() {
    return (
      <div className="DocumentDisplayName" data-testid="DocumentDisplayName">
        {this.renderDocumentText()}
      </div>
    );
  }
}

PureDocumentDisplayName.displayName = 'DocumentDisplayName';

PureDocumentDisplayName.propTypes = {
  issueStartingVersion: PropTypes.number,
  document: PropTypes.object,
  issueId: PropTypes.string,
  allowLink: PropTypes.bool.isRequired,
  navigateToIssueInDocumentAction: PropTypes.func.isRequired,
  location: PropTypes.object,
};

export default connect(null, {
  navigateToIssueInDocumentAction,
})(PureDocumentDisplayName);

